import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  otherFileViewerWrapper: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    position: 'absolute',
  },

  fileContainer: {
    backgroundColor: theme.palette.grey[50],
    borderRadius: '4px',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: 'auto',
    maxWidth: '100px',
    maxHeight: '100px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
